import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../../utils/request';

const getOrderedParts = createAsyncThunk('orderedParts/getOrderedParts',
  async (_, { rejectWithValue, getState }) => {
    try {
      const {
        page, size, order, query, partStatus, orderDateTo, orderDateFrom, orderedType
      } = getState().orderedPartsFilter;

      const { data } = await authGet('/co/ordered_parts',
        {
          params: {
            size,
            page,
            ...(order && { order }),
            ...(query && { query }),
            ...(partStatus && { partStatus }),
            ...(orderedType && { orderedType }),
            ...(orderDateTo && { orderDateTo }),
            ...(orderDateFrom && { orderDateFrom }),
          }
        });
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default getOrderedParts;
